import { render, staticRenderFns } from "./Imgx.vue?vue&type=template&id=59561764&"
import script from "./Imgx.vue?vue&type=script&lang=js&"
export * from "./Imgx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports